//styles
import {
  PageSection,
  PageSectionInner,
  PageSectionTitle,
} from '@/components/PageSection';
import { SrOnly } from '@/components/Card/Card.styles';
import { FactsTable } from './KeyFacts.styles';

export function KeyFacts({ content }) {
  return (
    <PageSection $off>
      <PageSectionInner>
        <PageSectionTitle>{content.title}</PageSectionTitle>
        <FactsTable>
          <caption>
            <SrOnly>{content.caption}</SrOnly>
          </caption>
          <thead>
            <tr>
              <th scope="col">{content.fact_label}</th>
              <th scope="col">{content.brand_label}</th>
            </tr>
          </thead>
          <tbody>
            {content.rows.map((row) => (
              <tr key={`key-fact-${row.fact}`}>
                <th scope="row">{row.fact}</th>
                <td>{row.value}</td>
              </tr>
            ))}
          </tbody>
        </FactsTable>
      </PageSectionInner>
    </PageSection>
  );
}
